import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { HeroSection } from '../components/landing/HeroSection';
import { FeaturesSection } from '../components/landing/FeaturesSection';
import { StatsSection } from '../components/landing/StatsSection';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { PricingSection } from '../components/landing/PricingSection';
import { CTASection } from '../components/landing/CTASection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white dark:bg-dark-surface" data-id="element-988">
      <Navbar data-id="element-989" />
      <HeroSection data-id="element-990" />
      <FeaturesSection data-id="element-991" />
      <StatsSection data-id="element-992" />
      <TestimonialsSection data-id="element-993" />
      <PricingSection data-id="element-994" />
      <CTASection data-id="element-995" />
      <Footer data-id="element-996" />
    </div>;
}